import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                Tracking Imports Status
                            </h2>

                            <h3 className="">Imports Section</h3>
                            <p>
                                You can track import status in the section <u>"Imports"</u> or calling the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/get_event_import">Imports Status API</a>.
                                <br />
                                In this section you can see the aggregated status of the imports. Each import has an unique transaction id.
                                <br />
                                <u>Imports Matchrate</u> is calculated on how much ids are found int the Audiencerate matchtable. If the ids loaded are mobile
                                ids we pass-through the matchtable, so it will always match 100%.
                            </p>
                            <p>
                                To search for a particular import you can filter using the Import's Transaction ID in the Dashboard or by calling the{' '}
                                <a href="https://apidocs.audiencerate.com/#/default/get_event_import">Imports Status API</a> like this:
                                'https://api.audiencerate.com/event/import?filter=TXID'
                                <br />
                                Please see the "AWS CLI UPLOAD CODE SNIPPET" example to see this flow in action: in the{' '}
                                <a href="/servertoserver">S2S Integration</a> section of the dashboard under the "Code Snippet" tab.
                            </p>

                            <h3 className="">Syncs Section</h3>
                            <p>
                                If the audience is licensed you will also see events of the synchronization process to Google in the <u>"Syncs"</u> section or
                                calling the <a href="https://apidocs.audiencerate.com/#/default/get_event_sync">Syncs Status API</a>.
                                <br />
                                In this section you can see the aggregated status of the syncs to Google. Each syncs has an unique transaction id that is
                                connected to the relative import.
                                <br />
                                <u>Syncs Matchrate</u> is calculated on how many unique ids are send to destination DMP minus how many error we receive back (ID
                                not found or expired, connection errors, ...)
                            </p>

                            <h3 className="">Import Performance</h3>
                            <p>Overing the mouse on the matchrate results will shows a popup with the import and sync statistics.</p>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
